import { gql } from '../__generated__';

export const FOLLOWED_COMPANIES_QUERY = gql(`
  query xcpFollowedCompanies($first: Int, $after: String) {
    viewer {
      id
      followedCompanies(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            company {
              ...CompanyData
            }
          }
        }
      }
    }
  }
`);
